/**
 * コメントやエモートをポップアウト表示中のtabであるかを判定する
 * is_pop_out=1 の場合、ポップアウト表示中のtabとみなす
 */

export const POP_OUT_QUERY_PARAM_KEY = "is_pop_out";
export const POP_OUT_QUERY_PARAM_VALUE = "1";

export const isPopOut = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get(POP_OUT_QUERY_PARAM_KEY) === POP_OUT_QUERY_PARAM_VALUE;
};
